import { render, staticRenderFns } from "./FormBuilderForm.vue?vue&type=template&id=25b3700c&"
import script from "./FormBuilderForm.vue?vue&type=script&lang=js&"
export * from "./FormBuilderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports